import React from "react";
import { X, ExternalLink } from "lucide-react";
import { T } from "@/context/LanguageContext";

export function MapModal({ place, onClose }) {
  const { latitude, longitude, official_name } = place;
  if (latitude == null || longitude == null) return null;
  const d = 0.4;
  const bbox = `${longitude - d}%2C${latitude - d}%2C${longitude + d}%2C${latitude + d}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${latitude}%2C${longitude}`;
  const full = `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=10/${latitude}/${longitude}`;
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-navy/70 p-4 backdrop-blur-sm"
      onClick={onClose}
      data-testid="map-modal"
    >
      <div className="relative w-full max-w-4xl overflow-hidden rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-border px-5 py-3">
          <h3 className="font-display text-lg font-bold text-navy">{official_name}</h3>
          <button onClick={onClose} className="rounded-full p-1.5 text-muted-foreground hover:bg-parchment hover:text-navy" data-testid="map-modal-close">
            <X className="h-5 w-5" />
          </button>
        </div>
        <iframe title="map" src={src} className="h-[65vh] w-full border-0" loading="lazy" />
        <a href={full} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 border-t border-border py-2.5 text-sm font-medium text-navy hover:bg-parchment">
          <T>Open full map</T> <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
    </div>
  );
}
